"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Experience;

var _Experience = require("@adobe/react-spectrum-workflow/dist/Experience");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Experience(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Experience.A4uExperience, null));
}